export default __webpack_public_path__ + "static/gilroy-light-da0bb698087533293c5af0851b958a97.woff2";